import './App.css';
import About from "./components/About.js"
import Publications from './components/Publications';

function App() {
  return (
    <div class="container mx-auto px-7 py-7 sm:px-10 sm:py-10 md:px-15 md:py-15 lg:px-20 lg:py-10 md:w-100">
    <About/>
    <Publications/>
    </div>
  );
}

export default App;
